import { Overlay } from "./overlay"
import { useNetworkStatus } from "../../../hooks/useNetworkStatus"
import { t } from "i18next"

export const NetworkOverlay = () => {
  const { isOffline } = useNetworkStatus()

  if (isOffline) {
    return (
      <Overlay
        title={t("You have been disconnected")}
        description={t(
          "You will be reconnected as soon as your internet connection is restored."
        )}
      />
    )
  }

  return null
}
